module.exports = __webpack_public_path__ + "img/horn.e38b643c.png";